import { lazy } from 'react';
import retry from '../../utils/webpack/chunkRetry';
const ModuleLoaderLazy = lazy(()=>retry(()=>import(/* webpackChunkName: "estimated_earnings" */ './ModuleLoader')));
export default ModuleLoaderLazy;
